<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <el-row>
          <div style="float: left; margin-right: 10px">
            <label style="color: #606266">所属栏目：</label>
            <el-cascader
              ref="cascaderType"
              v-model="searchModel.TypeCode"
              :options="options"
              :props="{ multiple: true }"
              clearable
            />
          </div>
          <div style="float:left;margin-right: 10px">
            <label style="color: #606266">状态：</label>
            <el-select
              v-model="state"
              placeholder="请选择"
              clearable
              @change="loadData"
            >
              <el-option
                v-for="item in stateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div style="float: left">
            <label style="color: #606266;float: left">关键字：</label>
            <el-input
              clearable
              v-model="searchModel.SearchKey"
              placeholder="请输入内容"
              size="small"
              style="width: 290px;margin-right:10px"
            ></el-input>
            <el-button
              size="small"
              icon="el-icon-search"
              type="danger"
              @click="loadData"
              >查询</el-button
            >
          </div>
        </el-row>
      </div>
      <div slot="toolBar" class="search-btn">
        <el-row>
          <el-button
            v-access:add
            icon="el-icon-plus"
            @click="$refs.editForm.create()"
            size="small"
            type="danger"
            >新增
          </el-button>
          <el-button
            v-access:delete
            icon="el-icon-delete"
            size="small"
            :disabled="isDelete"
            @click="batchDel"
            >删除
          </el-button>
        </el-row>
      </div>

      <div>
        <el-table
          border
          hightlight-current-row
          style="width: 100%"
          :header-cell-class-name="headerRow"
          :data="listData"
          :max-height="tableMaxHeight()"
          v-loading="isloading"
          @selection-change="onSelectionChange"
        >
          <el-table-column
            type="selection"
            width="50"
            align="center"
            :selectable="chkstu"
          ></el-table-column>
          <el-table-column
            prop="Title"
            label="标题"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="TypeName"
            label="所属栏目"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              {{scope.row.TypeName.replace(/,/gi, ' / ')}}
            </template>
          </el-table-column>
          <el-table-column
            prop="ReviewStatus"
            label="发布状态"
            align="center"
            :formatter="formatterStatus"
            width="90"
          ></el-table-column>
          <el-table-column
            prop="Creator"
            label="发布人"
            align="center"
            width="100"
          />
          <el-table-column label="创建时间" width="135" align="center"
            ><template slot-scope="scope">
              {{ (scope.row.CreateTime * 1000) | formatDate }}
            </template></el-table-column
          >
          <el-table-column label="发布时间" width="135" align="center"
            ><template slot-scope="scope">
              {{ (scope.row.ReleaseTime * 1000) | formatDate }}
            </template></el-table-column
          >
          <el-table-column label="操作" width="190" align="center">
            <template slot-scope="scope">
              <el-button
                v-access:read
                @click="$refs.queryForm.create(scope.row.Id)"
                type="text"
                size="mini"
                v-if="check(scope.row)"
                >详情
              </el-button>
              <el-button
                v-access:modify
                @click="innertop(scope.row)"
                type="text"
                size="mini"
                v-if="top(scope.row)"
                >置顶
              </el-button>
              <el-button
                v-access:modify
                @click="innertop(scope.row)"
                type="text"
                size="mini"
                v-if="untop(scope.row)"
                >取消置顶
              </el-button>
              <el-button
                v-access:modify
                v-if="scope.row.ReviewStatus === 4"
                @click="innerEdit(scope.row)"
                type="text"
                size="mini"
                >编辑
              </el-button>
              <el-button
                v-access:modify
                @click="innerrelease(scope.row)"
                type="text"
                size="mini"
                v-if="release(scope.row)"
                >发布
              </el-button>
              <el-button
                v-access:modify
                @click="innercancel(scope.row)"
                type="text"
                size="mini"
                v-if="cancel(scope.row)"
                >取消发布
              </el-button>
              <el-button
                v-access:delete
                @click="innerDel(scope.row)"
                type="text"
                size="mini"
                v-if="editor(scope.row)"
                >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </div>
    </BasePage>
    <edit-form ref="editForm" @onOk="loadData()" />
    <query-form ref="queryForm" />
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page"
import OfSearch from "@/components/controls/of_search/of_search"
import OfPagination from "@/components/controls/of_pagination/of_pagination"
import { mapGetters } from "vuex"
import EditForm from "@/modules/zjrc/pages/information/news/edit"
import QueryForm from "@/modules/zjrc/pages/information/news/query"
import api from "@/modules/zjrc/api"

export default {
  name: "list",
  components: {
    BasePage,
    OfSearch,
    OfPagination,
    EditForm,
    QueryForm,
  },
  data() {
    return {
      options: [], //新闻类型
      placeholder: "请输入文章标题", //搜索框提示文字
      isloading: false, //新增按钮控制
      isDelete: true, //删除按钮控制
      headerRow: "header-row",
      listData: [], //table数据
      total: 0, //文章数量
      currentPage: 1, //当前页面
      pageSize: 15, //每页数量
      EditVisible: false, //编辑页控制
      QueryVisible: false, //查询页控制
      formData: {}, //详情对象,
      formTitle: "", //弹窗标题
      domain: "", //域名
      url: "",
      searchModel: {
        SearchKey: '',
        TypeCode: ''
      }, //搜索条件
      ids: [], //批量删除数组
      state: null,
      stateOptions: [
        { label: "全部", value: "" },
        { label: "草稿", value: 4 },
        // {label: '待审核',value: 1},
        { label: "已发布", value: 2 },
        // {label: '审核通过',value: 3}
      ],
    }
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
    check() {
      return (data) => {
        return data.ReviewStatus !== 4
      }
    },
    editor() {
      return (data) => {
        return data.ReviewStatus > 2
      }
    },
    release() {
      return (data) => {
        return (
          data.ReviewStatus === 3 || (data.ReviewStatus === 4 && !data.IsAudit)
        )
      }
    },
    cancel() {
      return (data) => {
        return data.ReviewStatus === 2
      }
    },
    top() {
      return (data) => {
        return data.ReviewStatus === 2 && data.Top != 1
      }
    },
    untop() {
      return (data) => {
        return data.ReviewStatus === 2 && data.Top == 1
      }
    },
  },
  mounted() {
    this.loadData()
    this.getOptions()
  },
  methods: {
    getOptions() {
      const vm = this;
      api.getNewsTypeOptions().then((res) => {
        if (res.data.Code == 0) {
          vm.options = res.data.Data;
        }
      });
    },
    loadData() {
      this.isloading = true
      this.searchModel
      let typeCode = ''
      debugger
      if(this.searchModel.TypeCode.length > 0){
        typeCode = this.searchModel.TypeCode.map(x=>x[x.length - 1]).join()
      }
      debugger
      let params = {
        PageIndex: this.currentPage,
        PageSize: this.pageSize,
        SearchKey: this.searchModel.SearchKey,
        TypeCode: typeCode,
        State: this.state,
      }
      api
        .QueryNews(params)
        .then((res) => {
          if (res.data.Code === 0) {
            this.total = res.data.Data.total
            this.listData = res.data.Data.rows
          }
        }).finally(() => {
          this.isloading = false
        })
    },
    getParentName(option, id) {
      option.forEach((item, index) => {
        if (item.id == id[id.length - 1]) {
          this.searchModel.TypeId = item.id
          return
        } else if (item.children != null && item.children.length > 0) {
          this.getParentName(item.children, id)
        }
      })
    },
    search(keyword) {
      this.searchModel.SearchKey = keyword
      this.currentPage = 1
      this.loadData()
    },
    //新增
    add() {
      this.formTitle = "新建文章"
      this.formData = { ReviewStatus: 4, ReleaseTime: "" }
      this.EditVisible = true
    },
    //回调
    EditCallBack(data) {
      this.EditVisible = false
      if (data) {
        this.loadData()
      }
    },
    //批量删除
    batchDel() {
      this.$confirm("请确认是否批量删除选中的数据？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        api
          .DeleteNewsInBatches(this.ids)
          .then((res) => {
            if (res.data.Code === 0) {
              this.$message({
                message: "置顶成功",
                type: "success",
              })
              this.currentPage = 1
              this.loadData()
            } else {
              this.$message({
                message: res.data.Message,
                type: "error",
              })
            }
          })
          .catch((e) => {
            this.$message({
              message: e.toString(),
              type: "error",
            })
          })
      })
    },
    //表格高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight
      var tableMaxHeight = 0
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 303
      }
      return tableMaxHeight
    },
    //选中事件
    onSelectionChange(rowData) {
      this.isDelete = !rowData.length > 0
      this.ids = []
      if (rowData.length) {
        rowData.forEach((item) => {
          this.ids.push(item.Id)
        })
      }
    },

    chkstu(rowData) {
      return rowData.ReviewStatus > 2
    },
    //状态
    formatterStatus(rowData) {
      if (rowData.ReviewStatus === 1) {
        return "审核中"
      } else if (rowData.ReviewStatus === 2) {
        return "已发布"
      } else if (rowData.ReviewStatus === 3) {
        return "已审核"
      } else if (rowData.ReviewStatus === 4) {
        return "草稿"
      }
    },
    //修改每页数量
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.loadData()
    },
    //切换页码
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.currentPage = val
        this.loadData()
      }
    },
    //置顶
    innertop(rowData) {
      this.$confirm("请确认是否置顶选中的数据？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = Object.assign({}, { Id: rowData.Id })
        api
          .UpdateNewsTopById(params)
          .then((res) => {
            if (res.data.Code === 0) {
              this.$message({
                message: "置顶成功",
                type: "success",
              })
              this.currentPage = 1
              this.loadData()
            } else {
              this.$message({
                message: res.data.Message,
                type: "error",
              })
            }
          })
          .catch((e) => {
            this.$message({
              message: e.toString(),
              type: "error",
            })
          })
      })
    },
    //编辑
    innerEdit(rowData) {
      // this.formData = Object.assign({}, rowData)
      // if (this.formData.ReleaseTime !== null) {
      //   this.formData.ReleaseTime = this.formData.ReleaseTime * 1000
      // }
      // this.formTitle = "修改文章"
      // this.EditVisible = true
      this.$refs.editForm.create(rowData.Id)
    },
    //发布
    innerrelease(rowData) {
      let tips = { warn: "请确认是否发布选中的数据？", success: "发布成功！" }
      let params = { Id: rowData.Id, ReviewStatus: 2 }
      this.updateStatus(tips, params)
    },
    //取消发布
    innercancel(rowData) {
      let tips = {
        warn: "请确认是否取消发布选中的数据？",
        success: "取消发布成功！",
      }
      let params
      if (rowData.IsAudit) {
        params = { Id: rowData.Id, ReviewStatus: 3 }
      } else {
        params = { Id: rowData.Id, ReviewStatus: 4 }
      }
      this.updateStatus(tips, params)
    },
    updateStatus(tips, params) {
      this.$confirm(tips.warn, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        api
          .UpdateNewsStatus(params)
          .then((res) => {
            if (res.data.Code === 0) {
              this.$message({
                message: tips.success,
                type: "success",
              })
              this.loadData()
            } else {
              this.$message({
                message: res.data.Message,
                type: "error",
              })
            }
          })
          .catch((e) => {
            this.$message({
              message: e.toString(),
              type: "error",
            })
          })
      })
    },
    //删除
    innerDel(rowData) {
      this.$confirm("请确认是否删除选中的数据", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = { Id: rowData.Id }
        api
          .DeleteNewsById(params)
          .then((res) => {
            if (res.data.Code === 0) {
              this.$message({
                message: "删除成功",
                type: "success",
              })
              this.currentPage = 1
              this.loadData()
            } else {
              this.$message({
                message: res.data.Message,
                type: "error",
              })
            }
          })
          .catch((e) => {
            this.$message({
              message: e.toString(),
              type: "error",
            })
          })
      })
    },
    //获取域名
    getDomainPrefix() {
      api.QueryDomainPrefix().then((res) => {
        if (res.data.Code === 0) {
          this.domain = res.data.Data
        }
      })
    },
    //查询
    innercheck(rowData) {
      this.formTitle = "查询详情"
      this.formData = rowData
      this.QueryVisible = true
    },
    QueryCallBack() {
      this.QueryVisible = false
    },
  },
}
</script>
